import { render } from "./DeletexIconCircle.vue?vue&type=template&id=08ac1334&ts=true"
import script from "./DeletexIconCircle.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeletexIconCircle.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DeletexIconCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08ac1334"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08ac1334', __exports__)) {
    api.reload('08ac1334', __exports__)
  }
  
  module.hot.accept("./DeletexIconCircle.vue?vue&type=template&id=08ac1334&ts=true", () => {
    api.rerender('08ac1334', render)
  })

}


export default __exports__